<div class="card contact-form">
  <div class="card-body">
    <form id="contactForm" (ngSubmit)="mailSendClick()">

      <h4 class="fw-normal text-start" i18n="@@ContactFormHeader">Send your questions to our Customer Service</h4>

      <div class="row justify-content-start mx-0 mt-4">
        <h5 class="text-start" i18n="@@ContactFormCompanyDataHeader">About yourself</h5>

        <div class="mt-1 col-xxl-12">
          <div class="card-body p-0">

            <div class="row justify-content-start">
              <div class="mt-2 col-lg-6">
                <div class="form-floating">
                  <input class="form-control" type="text" name="companyInput" id="companyInputField"
                    [(ngModel)]="company" #companyInput="ngModel" required placeholder=" "
                    (change)="company = company?.trim()">
                    <label for="companyInputField" i18n="@@ContactFormCompanyInputLabel">Company name</label>
                  </div>
                </div>
                <div class="mt-2 col-lg-6">
                  <div class="form-floating">
                    <input class="form-control" type="text" name="customerNumberInput" id="customerNumberInputField"
                      [(ngModel)]="customerNumber" #customerNumberInput="ngModel" placeholder=" "
                      (change)="customerNumber = customerNumber?.trim()">
                      <label for="customerNumberInputField" i18n="@@ContactFormCustomerNumberInputLabel">Customer #</label>
                    </div>
                  </div>
                </div>

                <div class="row justify-content-start">
                  <div class="mt-2 col-lg-6">
                    <div class="form-floating">
                      <input class="form-control" type="text" name="customerNameInput" id="customerNameInputField"
                        [(ngModel)]="customerName" #customerNameInput="ngModel" required placeholder=" "
                        (change)="customerName = customerName?.trim()">
                        <label for="customerNameInputField" i18n="@@ContactFormCustomerNameInputLabel">Your name</label>
                      </div>
                    </div>
                  </div>

                  <div class="row justify-content-start">
                    <div class="mt-2 col-lg-6">
                      <div class="input-group flex-nowrap text-nowrap">
                        <div class="form-floating flex-grow-1">
                          <input class="form-control" type="tel" name="telephoneInput" id="telephoneInputField"
                            [(ngModel)]="telephone" #telephoneInput="ngModel" placeholder=" "
                            (change)="telephone = telephone?.trim()">
                            <label for="telephoneInputField" i18n="@@ContactFormTelephoneInputLabel">Telephone</label>
                          </div>
                          <span class="input-group-text">
                            <i class="bi bi-telephone"></i>
                          </span>
                        </div>
                      </div>
                      <div class="mt-2 col-lg-6">
                        <div class="input-group flex-nowrap text-nowrap">
                          <div class="form-floating flex-grow-1">
                            <input class="form-control" type="text" [pattern]="inputValidationEmailRegexPattern"
                              name="eMailInput" id="eMailInputField" [(ngModel)]="eMail" #eMailInput="ngModel" required
                              placeholder=" " (change)="eMail = eMail?.trim()">
                              <label for="eMailInputField" i18n="@@ContactFormEMailInputLabel">E-Mail</label>
                            </div>
                            <span class="input-group-text">
                              <i class="bi bi-envelope"></i>
                            </span>
                          </div>
                        </div>
                      </div>

                      <div class="row justify-content-start">
                        <div class="mt-2 col-lg-6 col-xxl-4">
                          <div class="form-floating">
                            <input class="form-control" type="text" name="streetInput" id="streetInputField" [(ngModel)]="street"
                              #streetInput="ngModel" placeholder=" " (change)="street = street?.trim()">
                              <label for="streetInputField" i18n="@@ContactFormStreetInputLabel">Street</label>
                            </div>
                          </div>
                          <div class="mt-2 col-md-4 col-lg-6 col-xxl-2">
                            <div class="form-floating">
                              <input class="form-control" type="text" name="zipCodeInput" id="zipCodeInputField"
                                [(ngModel)]="zipCode" #zipCodeInput="ngModel" placeholder=" " (change)="zipCode = zipCode?.trim()">
                                <label for="zipCodeInputField" i18n="@@ContactFormZipCodeInputLabel">Zipcode</label>
                              </div>
                            </div>
                            <div class="mt-2 col-md-8 col-lg-6 col-xxl-3">
                              <div class="form-floating">
                                <input class="form-control" type="text" name="cityInput" id="cityInputField" [(ngModel)]="city"
                                  #cityInput="ngModel" placeholder=" " (change)="city = city?.trim()">
                                  <label for="cityInputField" i18n="@@ContactFormCityInputLabel">City</label>
                                </div>
                              </div>
                              <div class="mt-2 col-lg-6 col-xxl-3">
                                <div class="form-floating">
                                  <app-country-combo-box name="contactCountryCodeSelectField" class="form-control px-0 py-0"
                                    [countryList]="countryList" [selectedCountry]="selectedCountry"
                                  (valueChanged)="onCountryCodeChange($event)" required></app-country-combo-box>
                                  <label class="countryComboboxLabel" for="contactCountryCodeSelectField"
                                  i18n="@@ContactFormCountrySelectLabel">Country</label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="row justify-content-start mx-0 mt-4">
                        <h5 class="text-start" i18n="@@ContactFormMessageHeader">Your Message for us</h5>
                        <div class="mt-1 col-xxl-12">
                          <div class="card-body p-0">
                            <div class="mt-2 col-lg-6">
                              <div class="form-floating">
                                <input class="form-control" type="text" name="subjectInput" id="subjectInputField" [(ngModel)]="subject"
                                  #subjectInput="ngModel" required placeholder=" " (change)="subject = subject?.trim()">
                                  <label for="subjectInputField" i18n="@@ContactFormSubjectInputLabel">Subject</label>
                                </div>
                              </div>
                              <div class="form-floating mt-2">
                                <textarea class="form-control mt-2 messageInputArea" name="messageInput" id="messageInputField"
                                  #messageInput="ngModel" required rows="3" [(ngModel)]="message" placeholder=" "
                                (change)="message = message?.trim()"></textarea>
                                <label for="messageInputField" i18n="@@ContactFormMessageInputLabel">Message</label>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="form-check ms-2 mt-4">
                          <input class="form-check-input" type="checkbox" [checked]="shouldSendCopyToContactPerson" (change)="shouldSendCopyToContactPerson = !shouldSendCopyToContactPerson" id="emailCopySendToContactPersonCheckbox">
                          <label class="form-check-label" for="emailCopySendToContactPersonCheckbox" i18n="@@ContactFormEmailCopySendToContactPersonCheckboxLabel">Send a copy to my E-Mail address</label>
                        </div>

                        <div class="ms-2 mt-2">
                          <app-check-privacy [routerlink]="privacyCheckTarget.routerlink" [queryParams]="privacyCheckTarget.queryParams" (onChecked)="acceptPrivacyOnChecked($event)"></app-check-privacy>
                        </div>

                        <div class="d-flex justify-content-end mt-3">
                          <button class="btn btn-primary w-100 w-max-300px" type="submit" [disabled]="submitIsDisabled" i18n="@@ContactFormSubmitButton">Send message</button>
                        </div>

                      </form>
                    </div>
                  </div>

                  @if (isPending == true) {
                    <app-loading-indicator-base class="w-100" [loadingIndicatorStyle]="eLoadingIndicatorStyle.OVERLAY"></app-loading-indicator-base>
                  }